import { FETCH_CURRENTADVERTISER } from "../actions/types";

export const currentAdvertiserReducer = (state = null, action) => {
  switch (action.type) {
    case FETCH_CURRENTADVERTISER:
      return action.payload;
    default:
      return state;
  }
};
